import fetch from 'isomorphic-fetch';

import EnvironmentService from './environmentService';
import {RootState} from './store';

class PreloadStateService {
  private constructor() {}

  public static async fetchPreloadState(): Promise<RootState | undefined> {
    let preloadReduxState: RootState;
    try {
      const url = `${EnvironmentService.PUBLIC_URL}/preload-state.laptop.json?nocache=${new Date().getTime()}`;
      preloadReduxState = await fetch(url).then(response => response.json());
    } catch (e) {
      preloadReduxState = undefined;
    }

    return preloadReduxState;
  }
}

export default PreloadStateService;
